import { ITableContextMenuRecord, ITableRowContextMenuEvent } from '@app/modules/table/table-context-menu.interface';

/**
 * Собрать запись ПКМ таблицы по id
 * @param id Идентификатор строки
 */
export function createTableContextMenuRecord(id: string | number): ITableContextMenuRecord {
    return { id };
}

/**
 * Собрать событие ПКМ строки таблицы
 * @param event Событие мыши
 * @param record Запись
 */
export function createTableRowContextMenuEvent(
    event: MouseEvent,
    record: ITableContextMenuRecord,
): ITableRowContextMenuEvent {
    return { event, record };
}
